import axios from "axios";

export const API_URL =
  window.location.host === "test.minimath239.ru"
    ? import.meta.env.VITE_API_TEST_URL
    : import.meta.env.VITE_API_URL;

const $host = axios.create({
  baseURL: API_URL,
});

const authInterceptor = (config: any) => {
  config.headers.Authorization = localStorage.getItem("token")
    ? `Bearer ${localStorage.getItem("token")}`
    : null;
  //console.log(config)
  return config;
};

$host.interceptors.request.use(authInterceptor);

export { $host };
